import { Mail, Home, Shield } from 'react-feather';

import dashboards from './dashboards';

export default [
  ...dashboards,
  {
    id: 'home',
    title: 'Home',
    icon: <Home size={20} />,
    navLink: '/home',
  },
  {
    id: 'secondPage',
    title: 'Second Page',
    icon: <Mail size={20} />,
    navLink: '/second-page',
  },
  {
    id: 'access-control',
    title: 'Access Control',
    icon: <Shield size={20} />,
    action: 'read',
    resource: 'ACL',
    navLink: '/access-control',
  },
];
